import { renderNav } from './nav';
import { renderUnitPage, renderCommandCenter } from './pages/unit';
import { renderWorkersPage, hydrateWorkersPage } from './pages/workers';
import { loadData } from './store';
import { renderLeverStrip, wireLeverStrip, refreshRankings } from './lever-strip';

function currentHash(): string {
  return window.location.hash || '#/';
}

/** Pages built around the live ranking show the persistent lever strip; Worker Status doesn't. */
function showsLeverStrip(hash: string): boolean {
  return hash === '#/' || hash === '' || /^#\/units\/[a-z-]+$/.test(hash);
}

function renderContent(hash: string): { html: string; afterMount?: () => void } {
  if (hash === '#/' || hash === '') {
    return { html: renderCommandCenter() };
  }
  if (hash === '#/workers') {
    return { html: renderWorkersPage(), afterMount: hydrateWorkersPage };
  }
  const unitMatch = hash.match(/^#\/units\/([a-z-]+)$/);
  if (unitMatch?.[1]) {
    return { html: renderUnitPage(unitMatch[1]) };
  }
  return {
    html: `<div class="placeholder"><h2>Not found</h2><p>${hash}</p></div>`,
  };
}

function render(): void {
  const hash = currentHash();
  const { html, afterMount } = renderContent(hash);
  const app = document.getElementById('app');
  if (!app) return;
  const leverStrip = showsLeverStrip(hash) ? renderLeverStrip() : '';
  app.innerHTML = `
    <header>
      <img class="brand-logo" src="/abetech-logo-white-red.png" alt="AbeTech" height="26" />
      <h1>BNA Portal · Acme Manufacturing</h1>
      <nav>${renderNav(hash)}</nav>
    </header>
    ${leverStrip}
    <main>${html}</main>
  `;
  if (leverStrip) {
    wireLeverStrip();
    refreshRankings();
  }
  afterMount?.();
}

window.addEventListener('hashchange', render);

// Load the lever + BNA data once, then render. A loading frame shows first so the shell
// isn't blank while the two API calls resolve.
const app = document.getElementById('app');
if (app) app.innerHTML = `<main><div class="placeholder"><p>Loading…</p></div></main>`;
void loadData().then(render);
